import { Bar } from '@ant-design/charts';
import React, {useState, useEffect} from 'react';
import { Row, Segmented, Col } from 'antd';

const AppointmentChart = ({data}) => {
    const [segmentedValue, setSegmentedValue] = useState(1);
    const [graphData, setGraphData] = useState([]);

    useEffect(() => {
        arrangeData(data)
    }, [data, segmentedValue])

    const typeValues = {
        2: 'POSITIVE',
        3: 'NEGATIVE',
        4: 'WAITING'
    };

    const organizeBrandBased = (responseData) => {
        const brands = responseData.filter(i => i.b);
        const result = [];

        brands.forEach(appointment => {
            const definedItem = result.find(i => i.brand === appointment.b);
            if(definedItem) {
                definedItem.count += 1;
            } else {
                result.push({brand: appointment.b, count: 1})
            }
        });

        return result;
    };

    const organizeBrandStatusBased = (responseData) => {
        const brands = responseData.filter(i => i.b);
        const result = [];

        const typeFiltered = brands.filter(appointment => appointment.s === typeValues[segmentedValue]);
        typeFiltered.forEach(appointment => {
            const definedItem = result.find(i => i.brand === appointment.b)

            if(definedItem) {
                definedItem.count += 1;
            } else {
                result.push({brand: appointment.b, count: 1})
            }

        });

        return result;
    };

    const organizeEmployeeBased = (responseData) => {
        const memo = {};
        responseData.forEach(element => {
            if (memo.hasOwnProperty((element.e).toLocaleLowerCase('tr'))) {
                memo[(element.e).toLocaleLowerCase('tr')].count += 1;
                return;
            }

            memo[(element.e).toLocaleLowerCase('tr')] = {
                count:1,
                employee: element.e
            }
        });

        const result = Object.values(memo);
        return result;
    };

    const arrangeData = (responseData) => {
        const handler = graphDataHandlers[segmentedValue];
        const result = handler(responseData);

        setGraphData(result);
        return;
    };

    const graphDataHandlers = {
        1: organizeBrandBased,
        2: organizeBrandStatusBased,
        3: organizeBrandStatusBased,
        4: organizeBrandStatusBased,
        5: organizeEmployeeBased
    };

    const chartConfig = {
        data: graphData,
        xField: 'count',
        yField: segmentedValue === 5 ? 'employee' : 'brand',
        seriesField: segmentedValue === 5 ? 'employee' : 'brand',
        legend: {
          position: 'top-left',
        },
    };

    const segmentedOptions = [
        {label: 'Çalışan Bazlı', value: 5},
        {label: 'Marka Bazlı', value: 1},
        {label: 'Olumlu', value: 2},
        {label: 'Olumsuz', value: 3},
        {label: 'Bekleyen', value: 4}
    ];
    const shadowStyle = {
        boxShadow: '1px 2px 3px 1px rgba(0, 0, 0, 0.3)'
    };
    return(
        <>
          <Row style={shadowStyle}>
            <Col span={24}>
                <Row justify={'center'} align={'center'}>
                    <Segmented options={segmentedOptions} value={segmentedValue} onChange={setSegmentedValue}/>
                </Row>
                <Row justify={'center'} style={{marginTop: '8px'}}>
                    <Col span={18}>
                        <Bar {...chartConfig} appendPadding={8}/>
                    </Col>
                </Row>
            </Col>
          </Row>
        </>
    )
};

export default AppointmentChart;